import { createContext, useContext, useEffect, useState } from "react";
import { authApi } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // user: null = still checking, false = not authed, object = user
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  const refresh = async () => {
    setAuthLoading(true);
    try {
      const me = await authApi.me();
      setUser(me);
      return me;
    } catch {
      setUser(false);
      return null;
    } finally {
      setAuthLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const login = async (email, password) => {
    const u = await authApi.login(email, password);
    setUser(u);
    return u;
  };

  const register = async (payload) => {
    const u = await authApi.register(payload);
    setUser(u);
    return u;
  };

  const logout = async () => {
    try { await authApi.logout(); } catch {}
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, authLoading, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
